<template>
  <div class="mobilePage" :class="{ ios: os.isPhone }">
    <div class="pageA">
      <!-- 背景：模糊出血层 + 等比舞台，保证设计内容完整可见且不变形 -->
      <div class="sceneBleed" aria-hidden="true"></div>
      <div class="sceneStage">
        <img
          class="sceneMain"
          src="@/assets/images/mobile1/pageA/bg.webp"
          alt=""
        />
        <!-- 人物轮播：改用 FlowCarousel 组件（原来是 VP9+alpha 视频，
             iOS / WebKit 不合成 alpha 只能退化成首帧图，安卓内核还会拦自动播放） -->
        <FlowCarousel class="sceneCarousel" :items="carouselItems" />
        <!-- 标题 -->
        <img
          class="sceneTitle"
          src="@/assets/images/pc/pageA/title.gif"
          alt="黄果免费看 · AI成人短剧全面上线"
        />
        <!-- 马上开看：按设计稿定位在舞台内，不会压住画面文案 -->
        <div class="ctaBox">
          <img
            v-if="os.isPhone"
            class="downBtn"
            src="@/assets/images/mobile1/pageA/btn-open.webp"
            alt="马上开看"
            @click.stop="getApkInfo('ios', $event)"
          />
          <div
            v-else
            class="androidDownBox"
            :class="{
              hasSpare:
                switchData.androidDownUrl && switchData.channelApkAndDownUrl
            }"
          >
            <button
              v-if="
                switchData.androidDownUrl && switchData.channelApkAndDownUrl
              "
              class="alternateDownloadBtn downBtn"
              type="button"
              @click.stop="getApkInfo('androidSpare', $event)"
            >
              <span class="downloadBolt">ϟ</span>
              备用下载
            </button>
            <img
              class="downBtn"
              src="@/assets/images/mobile1/pageA/btn-open.webp"
              alt="马上开看"
              @click.stop="getApkInfo('android', $event)"
            />
          </div>
        </div>
      </div>
      <!-- 顶部：logo + 联系方式 -->
      <div class="header">
        <div class="brand">
          <img
            class="brandIcon"
            src="@/assets/images/mobile1/pageA/logo-icon.webp"
            alt=""
          />
          <img
            class="brandText"
            src="@/assets/images/mobile1/pageA/logo-text.webp"
            alt="黄果免费看"
          />
        </div>
        <div class="contactBox">
          <div v-if="swUrl" class="contactItem" @click="toPage(swUrl)">
            <span class="contactIcon">
              <img src="@/assets/images/mobile1/pageA/icon-sw.svg" alt="" />
            </span>
            <span class="contactText">合作</span>
          </div>
          <div v-if="qdUrl" class="contactItem" @click="toPage(qdUrl)">
            <span class="contactIcon contactIconQd">
              <img src="@/assets/images/mobile1/pageA/icon-qd.svg" alt="" />
            </span>
            <span class="contactText">渠道</span>
          </div>
          <div v-if="tgUrl" class="contactItem" @click="toPage(tgUrl)">
            <span class="contactIcon">
              <img src="@/assets/images/mobile1/pageA/icon-tg.svg" alt="" />
            </span>
            <span class="contactText">社群</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 安卓提示框 -->
    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <!-- 苹果提示框 -->
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";
import FlowCarousel from "@/components/FlowCarousel";
import { carouselItems } from "@/constants/carouselItems";

export default {
  components: { FlowCarousel },
  props: ["os", "configs", "switchData", "version"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,
      carouselItems,
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
        return newValue;
      });
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
    const referrer = sessionStorage.getItem("referrer");
    const dc = sessionStorage.getItem("dc");
    if (referrer && dc) {
      this.currUrl = referrer + "user.html?dc=" + dc;
    } else {
      if (referrer) {
        this.currUrl = referrer + "user.html";
      } else {
        this.currUrl = window.location.href;
      }
    }
    // 预加载安装教程弹窗背景（藏在 display:none 的 overlay 里不会自动拉取），
    // 防止弹出时正赶上下载跳转被中断
    new Image().src = require("@/assets/images/mobile1/iosTip.webp");
    new Image().src = require("@/assets/images/mobile1/android_tip.png");
  },
  methods: {
    // 剪贴板
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {}
      );
    },
    checkIsSafari() {
      let ua = this.os.userAgent.toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      const data = this.switchData || {};
      const isIos = this.os.isPhone;
      // 安卓仅在渠道包地址存在时才自动下载
      const downUrl = isIos ? data.iosDownUrl : data.channelApkAndDownUrl;
      if (!downUrl) return;
      // iOS 非 Safari 浏览器无法下载，已弹 Safari 提示，不自动触发
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        // 下载立即触发，安装教程弹窗延迟 5s 再弹出
        this.getApkInfo(isIos ? "ios" : "android", null, 5000);
      });
    },
    // 等页面资源加载完成再执行，避免下载跳转把加载中的图片全部中断
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      // 兜底：弱网下资源迟迟加载不完也要触发下载
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      // 上报点击（下载按钮）；自动触发时无点击事件，不上报
      if (!event) return;
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y
      });
    },
    toPage(path) {
      window.open(path);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.mobilePage {
  height: 100%;
  width: 100%;
  .pageA {
    width: 100%;
    min-height: 100%;
    height: 100dvh;
    background-color: #060606;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    // 出血层：铺满屏幕的模糊背景，用来填补舞台等比缩放后留下的边条
    .sceneBleed {
      position: absolute;
      inset: 0;
      z-index: 0;
      background: url("./../../../assets/images/mobile1/pageA/bg.webp")
        no-repeat center center;
      background-size: cover;
      filter: blur(20px) brightness(0.55);
      transform: scale(1.15);
      pointer-events: none;
    }

    // 舞台：固定 375x812 设计比例，按 contain 缩放，画面永远完整且不变形
    .sceneStage {
      position: relative;
      flex: 0 0 auto;
      width: min(100%, calc(100dvh * 375 / 812));
      height: min(100dvh, calc(100vw * 812 / 375));
      z-index: 1;
    }

    .sceneMain {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }

    // 人物轮播：设计稿 744x539 @ (2,307)，按舞台百分比定位。
    // 高度不写死：744x539 与组件设计稿 1200x870 宽高比一致（差 0.07%），
    // 组件会按容器宽度自己算出高度，正好落回 33.19%。
    .sceneCarousel {
      position: absolute;
      left: 0.267%;
      top: 18.904%;
      width: 99.2%;
      z-index: 2;
    }

    // 标题：设计稿 750x300 @ (-4,879)
    .sceneTitle {
      position: absolute;
      left: -0.533%;
      top: 54.126%;
      width: 100%;
      height: 18.473%;
      z-index: 3;
      pointer-events: none;
    }

    .header {
      box-sizing: border-box;
      padding: 4px 27.06px 2px;
      padding-top: calc(4px + env(safe-area-inset-top));
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      background: rgba(0, 0, 0, 0.66);
      border-bottom: 0.35px solid #3a3a3a;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 120;
    }

    .brand {
      display: flex;
      align-items: center;
      gap: 7.5px;
      .brandIcon {
        width: 30px;
        height: 30px;
        border-radius: 3px;
      }
      .brandText {
        width: 67.5px;
        height: 31.5px;
      }
    }

    .contactBox {
      display: flex;
      align-items: flex-start;
      gap: 6.7px;
      .contactItem {
        position: relative;
        width: 19px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.67px;
        cursor: pointer;
        // 扩大点击热区：不占布局、也不越过相邻入口（间距 6.7px，左右各留 0.35px）
        &::after {
          content: "";
          position: absolute;
          left: -3px;
          right: -3px;
          top: -4px;
          bottom: -4px;
        }
      }
      .contactIcon {
        position: relative;
        display: block;
        width: 19px;
        height: 19px;
        img {
          position: absolute;
          left: -15.07px;
          top: -10.04px;
          width: 49.13px;
          height: 49.13px;
          // 图标 svg 自带大片透明发光留白，会横跨到相邻入口上方抢走点击
          pointer-events: none;
        }
      }
      .contactIconQd img {
        left: -15.55px;
        top: -10.36px;
        width: 50.09px;
        height: 50.09px;
      }
      .contactText {
        font-size: 8px;
        font-family: -apple-system, "PingFang SC", "Helvetica Neue",
          "Microsoft YaHei", sans-serif;
        font-weight: 600;
        line-height: 11px;
        letter-spacing: 0.64px;
        color: #fff;
        white-space: nowrap;
        text-indent: 0.64px;
      }
    }

    // 按设计稿定位：舞台内 x=100 y=723.5，350x104(设计) → 175x52
    .ctaBox {
      position: absolute;
      left: 0;
      right: 0;
      top: 89.101%; // 723.5 / 812
      height: 6.404%; // 52 / 812
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
      .downBtn {
        display: block;
        height: 100%;
        width: auto;
        cursor: pointer;
      }
      .androidDownBox {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        &.hasSpare .downBtn {
          height: 86%;
        }
        .alternateDownloadBtn {
          box-sizing: border-box;
          padding: 0 12px;
          border: 2px solid #f6c35c;
          border-radius: 12px;
          background: linear-gradient(180deg, #ffe5a2 0%, #eca52e 100%);
          box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.62),
            0 0 10px rgba(242, 174, 52, 0.85);
          color: #0b0802;
          font-size: 17px;
          font-weight: 700;
          letter-spacing: 2px;
          white-space: nowrap;
          .downloadBolt {
            margin-right: 4px;
            font-size: 20px;
          }
        }
      }
    }
  }

  .androidOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/android_tip.png")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }

  .iosOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/iosTip.webp") no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      position: relative;

      .appName {
        font-size: 10px;
        font-weight: 500;
        color: #242423;
        position: absolute;
        left: 79px;
        bottom: 102px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .desc {
        font-size: 7px;
        font-weight: 500;
        color: #8f908f;
        position: absolute;
        left: 79px;
        bottom: 92px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
}

.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;

  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }

  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }

  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }

  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
